// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-22548f38]:root{--light_text_color:#666}.login-page__loading[data-v-22548f38]{display:flex;justify-content:center;align-items:center;height:100%;padding-top:60px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
